import React, { useMemo } from 'react';
import { Roll, dollars, money, pct0 } from './Ring';

/* Executive KPI strip — the five numbers management looks at first. Live board/overview data only. */
const Tile = ({ label, value, foot, right, p, color, testid, delay }) => (
  <div className="gpj-xk" style={{ '--xc': color, animationDelay: `${delay}ms` }} data-testid={testid}>
    <small><i />{label}</small>
    <strong><Roll value={value} /></strong>
    {p != null && <div className="gpj-track"><div className="gpj-fill" style={{ width: `${Math.min(100, p * 100)}%`, background: color }} /></div>}
    <em><span>{foot}</span>{right && <b>{right}</b>}</em>
  </div>
);

export default function ExecKpiStrip({ boardData, live }) {
  const board = boardData?.board || {};
  const { risk, overdue } = useMemo(() => {
    let r = 0, o = 0;
    [1, 2, 3, 4].forEach((w) => (board[w] || []).forEach((d) => {
      const h = (d.credit?.health || '').toUpperCase();
      if (h === 'OVERDUE') o += 1; else if (h === 'AT RISK') r += 1;
    }));
    return { risk: r, overdue: o };
  }, [board]);
  const target = Number(boardData?.monthly_target_amount || 0);
  const lodged = Number(boardData?.monthly_lodged_amount || 0);
  const st = live?.settled || {};
  const ph = live?.pipeline_health || {};
  const lp = target ? lodged / target : null;
  const sp = st.target ? Number(st.amount || 0) / st.target : null;
  return (
    <div className="gpj-exec" data-testid="gpj-exec-kpis">
      <Tile label="Lodged" value={dollars(lodged)} p={lp} color="var(--blue)" foot={target ? `of ${money(target, 0)} target` : 'No target set'} right={lp != null ? pct0(lp) : null} testid="gpj-xk-lodged" delay={0} />
      <Tile label="Approved" value={dollars(boardData?.approved_loan_amount)} color="var(--green)" foot="GCI" right={dollars(boardData?.approved_gci_amount)} testid="gpj-xk-approved" delay={60} />
      <Tile label="Settled" value={dollars(st.amount)} p={sp} color="var(--violet)" foot={st.target ? `of ${money(st.target, 0)} target` : `${st.count || 0} files`} right={sp != null ? pct0(sp) : null} testid="gpj-xk-settled" delay={120} />
      <Tile label="In flight" value={money(ph.value)} color="var(--cyan)" foot="Active files" right={String(ph.count ?? 0)} testid="gpj-xk-inflight" delay={180} />
      <Tile label="Needs attention" value={String(risk + overdue)} color={overdue ? 'var(--red)' : risk ? 'var(--amber)' : 'var(--green)'} foot={`${risk} at risk`} right={`${overdue} overdue`} testid="gpj-xk-attention" delay={240} />
    </div>
  );
}
